import { __rest } from "tslib";
import { createElement } from 'rax';
import { FieldElement } from '../field';
import Radio from '../radio';
export default class RadioField extends FieldElement {
    renderPreview(value) {
        const _a = this.props, { direction = 'hoz' } = _a, others = __rest(_a, ["direction"]);
        return <Radio.Group value={value} style={{ maxWidth: '100%' }} direction={direction} disabled {...others}/>;
    }
    renderControl() {
        const _a = this.props, { direction = 'hoz' } = _a, others = __rest(_a, ["direction"]);
        return <Radio.Group style={{ maxWidth: '100%' }} direction={direction} {...others}/>;
    }
}
RadioField.displayName = 'RadioField';
